<script>
// import {LineEffect} from '@/components/plots/atoms/vars'

export default {
  computed: {
    dasharray() {
      switch(this.effect) {
        case 'dashed': return '4, 3'
        case 'dotted': return '1, 6'
        default: return false
      }
    },
    linecap() {
      switch(this.effect) {
        case 'dotted': return 'round'
        default: return false
      }
    }
  },
  name: 'candela-legend',
  props: {
    colors: {type: Array, default: (i) => 0},
    effects: {type: String, default: () => 'solid'},
    index: {type: Array, default: () => []},
    title: {type: String, default: () => ''},
    type: {type: String, default: () => 'line'}
  }
}
</script>
<template>
  <div class='d-flex justify-center align-center flex-wrap mb-2 mt-4'>
    <span class='pr-1'>{{title}}&nbsp;</span>
    <div v-for='(l, i) in index' :key='i'
      class='d-flex align-center mr-2 flex-wrap'>
      <svg width='20' height='20' class='mr-1'>
        <line v-if='type == "line"' :stroke='colors[i]'
          x1='1' x2='19' y1='10.5' y2='10.5' stroke-width='3'
          :stroke-linecap='linecap' :stroke-dasharray='dasharray'/>
        <circle v-if='type == "circle"'
          r='5' cx='10' cy='10' :fill='colors[i]'/>
      </svg>
      <div class='label'>{{ l }}</div>
    </div>
  </div>
</template>
<style lang='sass' scoped>
.label
  white-space: nowrap !important

.theme--dark
  .label
    color: var(--v-grey-lighten6)
</style>
